import { useQuery } from '@tanstack/react-query'
import { fetchThreadMessages, isThreadsApiAvailable } from '@/services/chat/threadsApi'

export function useThreadPreviewMessages(thread, open) {
  const threadId = thread?.id
  const workspaceId = thread?.workspaceId
  const enabled = Boolean(open && threadId && isThreadsApiAvailable())
  const query = useQuery({
    queryKey: ['thread-preview-messages', threadId, workspaceId],
    queryFn: ({ signal }) => fetchThreadMessages(threadId, { signal, workspaceId }),
    enabled,
    staleTime: 15_000,
  })
  return {
    messages: Array.isArray(query.data) ? query.data : [],
    loading: enabled && query.isPending,
  }
}
